import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App, ProviderVerificationPage, SurveyPage } from './application';
import './styles.css';
import './theme.css';

function Root() {
  const surveyRoute = window.location.pathname.match(/^\/survey\/([0-9a-f]{64})$/i);
  if (surveyRoute?.[1]) return <SurveyPage token={surveyRoute[1]} />;
  if (window.location.pathname === '/provider-verification') {
    return <ProviderVerificationPage apiUrl={window.QUALITY_VET_CONFIG.apiUrl} />;
  }
  return <App />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
